const placeholders = {
  geocoder: {
    sk: 'Vyhľadať',
    cz: 'Vyhledat',
    en: 'Search'
  },
  sidebar: {
    sk: {
      graveNumber: 'Číslo hrobu',
      owner: 'Nájomník',
      ownerAddress: 'Adresa nájomníka',
      block: 'Blok',
      graveType: 'Typ hrobu',
      name: 'Mená pochovaných',
      rentStart: 'Začiatok nájmu',
      rentExpire: 'Koniec nájmu'
    },
    cz: {
      graveNumber: 'Číslo hrobu',
      owner: 'Nájemník',
      ownerAddress: 'Adresa nájemníka',
      block: 'Blok',
      graveType: 'Typ hrobu',
      name: 'Jména pohřbených',
      rentStart: 'Začátek nájmu',
      rentExpire: 'Konec nájmu'
    },
    en: {
      graveNumber: 'Grave number',
      owner: 'Tenant',
      ownerAddress: 'Tenant address',
      block: 'Block',
      graveType: 'Type of grave',
      name: 'Names of buried',
      rentStart: 'Start of rent',
      rentExpire: 'Expiration of rent'
    }
  },
  leafletMeasurement : {
    sk: {
      measure: 'Meranie vzdialeností a plôch',
      create: 'Vytvoriť nové meranie',
      startCreating: 'Vytvor nové meranie pridávaním bodov do mapy',
      cancel: 'Zrušiť',
      finish: 'Ukončiť meranie',
      lastPoint: 'Posledný bod',
      areaMeasurement: 'Plocha',
      pathDistance: 'Dĺžka',
      center: 'Priblíž na stred plochy',
      delete: 'Zmazať'
    },
    cz: {
      measure: 'Meranie vzdialeností a plôch',
      create: 'Vytvoriť nové meranie',
      startCreating: 'Vytvor nové meranie pridávaním bodov do mapy',
      cancel: 'Zrušiť',
      finish: 'Ukončiť meranie',
      lastPoint: 'Posledný bod',
      areaMeasurement: 'Plocha',
      pathDistance: 'Dĺžka',
      center: 'Priblíž na stred plochy',
      delete: 'Zmazať'
    },
    en: {
      measure: 'Measure distances and areas',
      create: 'Create a new measurement',
      startCreating: 'Start creating a measurement by adding points to the map',
      cancel: 'Cancel',
      finish: 'Finish measurement',
      lastPoint: 'Last point',
      areaMeasurement: 'Area measurement',
      pathDistance: 'Path distance',
      center: 'Center on this area',
      delete: 'Delete'
    }
  }
}

export { placeholders }



//////////////////
// WEBPACK FOOTER
// ./static/localization/placeholders.js
// module id = null
// module chunks = 